import React from 'react';
import { useNavigation } from '@react-navigation/native';
import { createGroupChannelCreateFragment } from '@sendbird/uikit-react-native';
import { withSendbirdConnection } from '../components';
import { IGroupChannelContentProps } from '../types';


const GroupChannelCreateFragment = createGroupChannelCreateFragment();


const GroupChannelCreateContent: React.FC<IGroupChannelContentProps> = () => {
    const navigation = useNavigation<any>();

    return (
        <GroupChannelCreateFragment
            onCreateChannel={async channel => {
                navigation.replace('GroupChannel', { channelUrl: channel.url });
            }}
            onPressHeaderLeft={() => {
                navigation.goBack();
            }}
        />
    );
};

export const GroupChannelCreateScreen = withSendbirdConnection(
    GroupChannelCreateContent,
    {
        useDetailedConnectionStatus: true,
    }
);
